var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgEmotion = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    d: "M7 12.833A5.833 5.833 0 1 0 7 1.167a5.833 5.833 0 0 0 0 11.666ZM5.133 8.401l-.003-.003A.583.583 0 0 0 4.2 9.1l.467-.35c-.467.35-.466.351-.466.351l.002.003.004.006.012.015.041.05a4.053 4.053 0 0 0 .683.63c.466.339 1.167.695 2.057.695.89 0 1.591-.356 2.057-.695a4.052 4.052 0 0 0 .683-.63l.04-.05.013-.015.004-.006.002-.002V9.1a.583.583 0 0 0-.93-.703l-.003.003-.02.024c-.02.023-.05.06-.093.104-.086.09-.215.211-.383.333-.336.245-.802.472-1.37.472-.568 0-1.034-.227-1.37-.472a2.887 2.887 0 0 1-.496-.46Zm-.612-1.693a1.02 1.02 0 1 0 0-2.041 1.02 1.02 0 0 0 0 2.041Zm5.98-1.02a1.02 1.02 0 1 1-2.043 0 1.02 1.02 0 0 1 2.042 0Z",
    clipRule: "evenodd"
  })));
});
SvgEmotion.displayName = "SvgEmotion";
export default SvgEmotion;